import {
  Component,
  ViewChild,
  TemplateRef,
  Inject,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CompanyAttributes, DocumentDetailClassAttributes, DocumentDetailTypeAttributes } from "@albatrosdeveloper/ave-models-package";
import { IRequestResult } from "app/common/interfaces";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { ToggleOptionComponent } from "app/shared/components/form-ui/toggle-option/toggle-option.component";
import { classToggles } from "../document-class-toogle.config";
import { DocumentLineClassService } from "../document-class-line.service";
import { DocumentLineTypeService } from "../../document-type-line/document-type-line.service";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";

@Component({
  selector: "app-form-document-class-line",
  templateUrl: "./form-document-class-line.component.html",
  styleUrls: ["./form-document-class-line.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    FormSectionComponent,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    ToggleOptionComponent,
  ],
  providers: [
    
  ],
})
export class FormDocumentClassLineComponent {

  //#region Action
  form!: FormGroup;
  id: string | null = null;

  documentTypeLineList: DocumentDetailTypeAttributes[] = [];
  filteredDocumentTypeLineList: DocumentDetailTypeAttributes[] = [];

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  classToggles = classToggles
  //#endregion

  constructor(
    private readonly documentLineClassService: DocumentLineClassService,
    private readonly documentLineTypeService: DocumentLineTypeService,
    private readonly companyService: CompanyService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<FormDocumentClassLineComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentDetailClassAttributes
  ) {
    
  }
 
  ngOnInit(): void {
    this.openModal(this.data);
  }

  //#region Action
  buildForm(document?: DocumentDetailClassAttributes): void {
    this.form = this.fb.group({
      code: [{ value: document?.code ?? '', disabled: !!this.id }, Validators.required],
      name: [document?.name ?? '', Validators.required],
      documentDetailTypeId: [document?.documentDetailType?._id ?? '', Validators.required],
      companyIds: [document?.companies?.map(company => company._id) ?? [], Validators.required],
    });

    this.classToggles.forEach(toggle => {
      this.form.addControl(toggle.field, this.fb.control(document ? document[toggle.field as keyof DocumentDetailClassAttributes] ?? false : false));
    });

    this.form.markAllAsTouched();
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.", "Cerrar", { duration: 5000 });
      }
    });
  }

  fetchDocumentTypeLines() {
    this.documentLineTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.documentTypeLineList = res.data;
        this.filteredDocumentTypeLineList = this.documentTypeLineList;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener los tipos de línea.", "Cerrar", { duration: 3000 }
        );
      },
    });
  }

  openModal(document?: DocumentDetailClassAttributes): void {
    this.getAllCompanies();
    this.fetchDocumentTypeLines();

    if (document) {
      this.buildForm(document)
      this.id = String(document._id)
    } else {
      this.buildForm();
      this.id = null
    }
  }

  onSubmit() {
    if (this.id == null) {
      this.createDocumentClassLine()
    } else {
      this.updateDocumentClassLine(this.id)
    }
  }

  createDocumentClassLine(): void {
    const payload = this.form.getRawValue();
    this.documentLineClassService.create(payload).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.dialogRef.close('yes');
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateDocumentClassLine(id: string): void {
    const payload = this.form.getRawValue();

    this.documentLineClassService.update(id, payload).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        this.dialogRef.close('yes');
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }
}
